import React, { Component } from "react";
import Divider from "material-ui/Divider";
import { Link } from "react-router-dom";
import routes from "../../routes";
import Logo from "../Logo";
import MenuButton from "../MenuButton";

class Header extends Component {
  render() {
    const { pathname } = this.props.location;
    const absolutePath =
      pathname.substr(-1) === "/" ? pathname.slice(0, -1) : pathname;
    return (
      <div>
        <Logo />
        {routes.filter(page => !page.skip).map((page, i) => (
          <Link key={"menu-item-" + i} to={page.path}>
            <MenuButton
              active={
                absolutePath === page.path ||
                (absolutePath.length === 0 && page.path === "/")
              }
            >
              {page.name}
            </MenuButton>
          </Link>
        ))}

        <Divider />
        <br />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js